import { hashData } from "../utils/utils";
class DataLayerService {
    constructor() {
        Object.defineProperty(this, "dataLayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        this.dataLayer = window.dataLayer;
    }
    sendEvent(eventName, eventParams) {
        this.dataLayer.push({
            event: eventName,
            ...eventParams
        });
        console.log(JSON.stringify({
            event: eventName,
            ...eventParams
        }));
    }
    sendUserEvent(dni, cellphone, accountName, path, client) {
        this.dataLayer.push({
            event: 'userData',
            userID: hashData(dni),
            userID2: hashData(cellphone),
            userAccountName: accountName,
            client: !!client ? client : '',
            PagePath: path,
            TimeStamp: new Date().getTime()
        });
        console.log(JSON.stringify({
            event: 'userData',
            userID: hashData(dni),
            userID2: hashData(cellphone),
            userAccountName: accountName,
            PagePath: path,
            TimeStamp: new Date().getTime()
        }));
    }
}
export default new DataLayerService();
